import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "PolicyPage",
  class: "shared-page"
}
const _hoisted_2 = { class: "centeredContentBox centeredContentBoxMedia" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["aria-busy"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CwePageHeader = _resolveComponent("CwePageHeader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CwePageHeader, {
      authenticationRequired: true,
      isApp: _ctx.isApp == true
    }, null, 8, ["isApp"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("link", {
        rel: "stylesheet",
        href: "/css/policy-styles.css"
      }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.htmlErrorMessage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "alertBox bottomSpace",
              innerHTML: _ctx.htmlErrorMessage
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "policy-section",
              "aria-busy": _ctx.loadingPolicy
            }, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.policyHeader), 1),
              _createElementVNode("div", {
                innerHTML: _ctx.policyText,
                class: "policyWrapper"
              }, null, 8, _hoisted_5)
            ], 8, _hoisted_4))
      ])
    ])
  ]))
}